import React, { ComponentType } from 'react';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';

import './Footer.scss';

import DSLogo from '../../assets/DataswiftLogo';
import { DSTheme } from '../../styles/themes/types';

type PropsType = {
  className?: string;
  CustomLogo?: ComponentType;
  margin?: boolean;
  role?: 'Admin' | 'Manager' | 'Developer';
};

export const Footer: React.FC<PropsType> = ({ className, CustomLogo, margin }) => {
  const theme = useTheme<DSTheme>();
  const themeType = theme.palette.type;

  return (
    <div className={`ds-footer-background ${themeType === 'light' ? 'light-grey' : themeType}`}>
      <Grid
        container
        className={`footer-container  ${margin ? 'margin' : ''}`}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid
          container
          className={`${className || 'ds-footer'}`}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item className="ds-footer-logo-wrapper">
            {CustomLogo || (
              <a href="https://dataswift.io">
                <DSLogo trademark fill={theme.palette.text.logo} />
              </a>
            )}
          </Grid>

          <a href="https://dataswift.io/legal/legal" className="ds-footer-terms">
            Terms & Conditions
          </a>
          <div className="ds-footer-text">
            ©2021 DATASWIFT LTD, a company incorporated in England and Wales with registered number
            09821157 whose registered office is at 8 Comberton Road, Barton, Cambridge, England,
            CB23 7BA.
          </div>

          <div className="ds-footer-text">
            Authorised and regulated by the{' '}
            <a href="https://www.hatcommunity.org/">HAT Community Foundation</a> and Financial
            Conduct Authority.
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
